// extracted by mini-css-extract-plugin
export default {"form":"newComment_form__JRGFO","row":"newComment_row__ecdaI","control":"newComment_control__Indsh","btn":"newComment_btn__OcCOC"};